module.exports = __webpack_public_path__ + "img/Broadsign.cc152cc4.png";